import { createStyles } from '@mantine/core';

export const useQuantityStyle = createStyles((theme) => ({
  groupStyle: {
    flexWrap: 'nowrap',
  },
  imageStyle: {
    cursor: 'pointer',
  },
}));
export const searchStyle = createStyles((theme) => ({
  item: {
    ':not(:last-child)': {
      position: 'relative',
      '&:before': {
        content: `''`,
        position: 'absolute',
        width: '98%',
        height: 1,
        backgroundColor: theme.colors.gray[2],
        bottom: 0,
        left: '50%',
        transform: 'translateX(-50%)',
      },
    },
  },
  scanItem: {
    background: '#FFFFFF',
    boxShadow: '0px 5px 10px rgba(0, 0, 0, 0.15)',
    borderRadius: '20px',
  },
  searchItem: {
    background: '#FFFFFF',
    boxShadow: '0px 5px 10px rgba(0, 0, 0, 0.15)',
    borderRadius: '20px',
    input: {
      fontSize: '12px',
      height: '60px',
      border: 'none',
    },
    'input:: placeholder': {
      fontSize: '12px',
    },
  },
  input: {
    height: 55,
    borderColor: theme.colors.gray[1],
    boxShadow: theme.shadows.sm,
    fontWeight: 500,
  },
  dropdownList: {
    itemsWrapper: {
      background: 'blue',
    },
  },
  content: {
    height: '37rem',
  },
}));

export const cardStyle = createStyles((theme) => ({
  list_item: {
    margin: 0,
    padding: 0,
    display: 'flex',
    listStyle: 'none',
    flexWrap: 'wrap',
    li: {
      padding: '2px 10px 0px 0px',
      margin: 1,
      fontSize: 11,
    },
    title: {
      fontSize: 11,
    },
  },
  web_list_item: {
    margin: 0,
    padding: 0,
    display: 'flex',
    listStyle: 'none',
    flexWrap: 'wrap',
    li: {
      padding: '2px 10px 0px 0px',
      margin: 1,
      fontSize: 13,
    },
    title: {
      fontSize: 13,
    },
  },
  addressStyle: {
    flexWrap: 'nowrap',
  },
  cardStyle: {
    background: '#FFFFFF',
    padding: 10,
  },
  circle: {
    background: '#43B61A',
    borderRadius: '50%',
    width: '7px',
    height: '7px',
    padding: 0,
    position: 'relative',
    top: '7px',
    right: '5px',
  },
  root: {
    height: '100%',
  },
  figure: {
    height: '100%',
  },
  image: {
    height: '100%',
  },
  imageWrapper: {
    height: '100%',
  },
}));
export const useComponentStyle = createStyles((theme) => ({
  scrollbar: {
    // height: "600px",
    width: 'auto',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: '10px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#f1f1f1',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#FB9F30',
      borderRadius: '5px',
    },
  },
}));
